if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.minicart = document.querySelector('mini-cart');
      this.eventContext = this.form.dataset.eventContext;
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) {
        return;
      }

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.button-overlay-spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.minicart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });

            this.handleErrorMessage(response.description);
            this.minicart.updateSectionContents();
            return;
    }

          this.minicart.renderContents(response);

          if (window.themeSettings.redirectToCart) {
            location.href = '/cart';
          } else {
            this.minicart.open(submitButton);
          }

          const event = new CustomEvent('cart:item-add', {
            detail: {
              items: [response],
              context: this.eventContext,
            },
          });
          document.dispatchEvent(event);

          publish(PUB_SUB_EVENTS.cartItemAdd, {
            source: this.eventContext,
            items: [response],
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.button-overlay-spinner').classList.add('hidden');
  });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) {
        return;
      }

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  }); // This closes the customElements.define function
}

  // Add the DOMContentLoaded event listener here
// Add the DOMContentLoaded event listener here
  document.addEventListener('DOMContentLoaded', function() {
  
    // Find the main product form
    const mainProductForm = document.querySelector('form[id^="product-form-template--"]');

    if (!mainProductForm) {
         return;
    }
    
    // Find the specific custom-liquid-right that directly contains the product-form__input-wrapper
    const inputWrapper = document.querySelector('.product-form__input-wrapper');
    const wrapperDiv = inputWrapper ? inputWrapper.closest('.custom-liquid-right') : null;
    
    // Ensure we have found the correct wrapper div
    if (!wrapperDiv) {
      return;
    }
   
    // Function to insert the entire wrapper div before the quantity input
    function insertCustomField() {
      const quantityInput = mainProductForm.querySelector('.quantity-input');

      if (quantityInput && !mainProductForm.contains(wrapperDiv)) {
        quantityInput.parentNode.insertBefore(wrapperDiv, quantityInput);
      }
    }
    

    // Call the function initially
    insertCustomField();

    // Set up a Mutation Observer to monitor changes in the main form
    const observer = new MutationObserver(insertCustomField);

    observer.observe(mainProductForm, {
      childList: true,
      subtree: true
    });
  });

 